import { SEARCH_CHECKBOXES, SEARCH_DROPDOWNS } from '../career_utils';
import FilterCheckbox from './FilterCheckbox';
import { SearchSelect } from './SearchSelect';

export const ApiFilter = ({ updateValue, values }) => {
  const { intranet_request, logged_in } = window.DREAMin;

  if (!values) return null;
  let checkboxes = [];
  if (scrivito.in_editable_view()) {
    checkboxes = SEARCH_CHECKBOXES;
  } else if (intranet_request || logged_in) {
    checkboxes = ['intranet_only'];
  }

  return (
    <div className="filter-partial has-margin-top">
      <div className="filter-row">
        {SEARCH_DROPDOWNS.map((attribute) => (
          <div className="filter-item">
            <SearchSelect
              key={attribute}
              field={attribute}
              onChangehandler={updateValue}
              selectedOptions={values[attribute]}
            />
          </div>
        ))}
      </div>

      <div className="filter-row">
        {!!checkboxes.length && (
          <div className="filter-item full flex">
            {checkboxes.map((attribute, index) => (
              <FilterCheckbox
                key={index}
                attribute={attribute}
                updateValue={updateValue}
                value={values[attribute]}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ApiFilter;
